import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AnimatedButton from 'common/components/animated_button';
import {
  TextInputField, PasswordInputField, SelectField, DateInputField, PhoneInputField,
  DEFAULT_REQUIRED_MESSAGE, PHONE_INVALID_MESSAGE
} from 'common/components/form_fields';
import PayoutAccounts from 'account/containers/payout/accounts';
import { isPhoneValid } from 'common/utils';

/* Simple wrapper around <PayoutAccounts /> so that we can display a validation error
   if no account is connected. */
const PayoutAccountsField = ({ input, meta }) => {
  const intro = (
    <div>
      <p>
        How do you want to be paid? Please choose one payment account. <br/>
        You can change this or add a second account any time after your application is approved.
      </p>
      <p className="text-warning">
        If selecting Payoneer, be sure you have pop-ups enabled or it won't work.
      </p>
    </div>
  );

  return (
    <div className="form-group">
      <PayoutAccounts onChange={input.onChange} intro={intro} useIconsToConnect={true}
        showOnlyOneAccount={true} />
      { meta.touched && meta.error && <div className="callout alert">{ meta.error }</div> }
    </div>
  );
}

const SettingsForm = ({
  error, handleSubmit, submitting, submitFailed, countryChoices, tzChoices
}) => (
  <form onSubmit={handleSubmit} className="account-form">

    <fieldset>
      <h4>Contact Info</h4>

      <Field name="first_name" label="First name" component={TextInputField} />
      <Field name="last_name" label="Last name" component={TextInputField} />
      <Field name="date_of_birth" label="Date of birth" component={DateInputField} />
      <Field name="address_line_1" label="Address" component={TextInputField} />
      <Field name="address_line_2" label="Address 2" component={TextInputField} />
      <Field name="city" label="City/Town" component={TextInputField} />
      <div className="row">
        <div className='columns small-16 medium-8'>
          <Field name="state" label="State/County/Province" component={TextInputField}/>
        </div>
        <div className='columns small-16 medium-8'>
          <Field name="postal_code" label="ZIP/Postal code" component={TextInputField}/>
        </div>
      </div>
      <div className="row">
        <div className='columns small-16 medium-8'>
          <Field name="country" label="Country" component={SelectField} options={countryChoices}/>
        </div>
      </div>
      <Field name="phone_number" label="Phone" component={PhoneInputField}/>
      <Field name="user_timezone" label="Timezone" component={SelectField} options={tzChoices} />
    </fieldset>

    <fieldset>
      <Field name="payout_accounts" component={PayoutAccountsField} />
    </fieldset>

    <AnimatedButton processing={submitting} type="submit" label="Next"
      baseBtnClass="btn-tertiary btn-block" processingLabel="Saving..."
      errorMsg={error || submitFailed} successMsg="Account Updated!"/>

  </form>
)

const validate = values => {
  const errors = {};
  const requiredFields = [
    'first_name', 'last_name', 'date_of_birth', 'address_line_1', 'city',
    'state', 'postal_code', 'country', 'phone_number', 'user_timezone',
  ];
  for (let f of requiredFields) {
    if (!values[f]) errors[f] = DEFAULT_REQUIRED_MESSAGE
  }
  if (values.payout_accounts.length == 0) {
    errors.payout_accounts = 'Please connect at least one account.'
  }
  if (values.phone_number && !isPhoneValid(values.phone_number)) {
    errors.phone_number = PHONE_INVALID_MESSAGE
  }

  return errors
}

export default reduxForm({
  form: "SettingsForm",
  validate,
})(SettingsForm);



// WEBPACK FOOTER //
// ./registration/creative/components/account_settings_form.jsx